import { Collection, getFirestore } from 'firestorter';

import CollectionName from '../utils/collections';
import BaseDocument from './BaseDocument';

class Package extends BaseDocument {
  get coachId() {
    return this.data.coachId;
  }

  get productId() {
    return this.data.productId || this.ref?.parent?.parent?.id;
  }

  get name() {
    return this.data.name;
  }

  get currency() {
    return this.data.currency;
  }

  get initialPaymentInCents() {
    return this.data.initialPaymentInCents;
  }

  get initialTerm() {
    return this.data.initialTerm;
  }

  get priceId() {
    return this.data.priceId;
  }

  get monthlyPaymentInCents() {
    return this.data.monthlyPaymentInCents;
  }

  get monthlyPriceId() {
    return this.data.monthlyPriceId;
  }

  get minSubscriptionMonths() {
    return this.data.minSubscriptionMonths;
  }

  get isArchived() {
    return !!this.data.isArchived;
  }

  get category() {
    return this.data.category || null;
  }

  setCategory(category) {
    return this.updateFields({ category });
  }

  static async getCategorizedPackages(coachId) {
    const db = getFirestore();
    const col = new Collection(
      () => db.collectionGroup(CollectionName.PACKAGE),
      {
        createDocument: (source, options) => new Package(source, options),
        query: (ref) => ref
          .where('coachId', '==', coachId)
          .where('category', '!=', null),
      },
    );
    await col.fetch();
    return col;
  }

  archive() {
    return this.updateFields({
      isArchived: true,
      archivedAt: new Date(),
    });
  }

  unarchive() {
    return this.updateFields({
      isArchived: false,
    });
  }
}

export default Package;
